import { Routes } from '@angular/router';
import { ROUTES } from '@shared/constants/routes';
import { dashboardRoutes } from 'app/features/private/candidate/dashboard/dashboard.routes';
import { PrivateLayout } from 'app/layouts/private-layout/private-layout';

export const candidateRoutes: Routes = [
  {
    path: ROUTES.HOME,
    component: PrivateLayout,
    children: [
      {
        path: '',
        loadComponent: () => import('../../features/private/candidate/home/home').then((m) => m.Home),
      },
      {
        path: ROUTES.PROFILE,
        loadComponent: () =>
          import('../../features/private/candidate/profile/profile').then((m) => m.Profile),
      },
      {
        path: ROUTES.CREATE_OPPORTUNITY,
        loadComponent: () =>
          import('../../features/private/candidate/create-opportunity/create-opportunity').then((m) => m.CreateOpportunityCandidate),
      },
      {
        path: ROUTES.DETAIL_OPPORTUNITY,
        loadComponent: () => import('../../features/private/candidate/detail-opportunity/detail-opportunity').then((m) => m.DetailOpportunityCandidate),
      },
      {
        path: ROUTES.UPDATE_OPPORTUNITY,
        loadComponent: () =>
          import('../../features/private/candidate/update-opportunity/update-opportunity').then((m) => m.UpdateOpportunityCandidate),
      },
      {
        path: ROUTES.YOURS_OPPORTUNITIES,
        loadComponent: () =>
          import('../../features/private/candidate/yours-opportunities/yours-opportunities').then((m) => m.YoursOpportunitiesCandidate),
      },
      {
        path: ROUTES.MESSAGES,
        loadComponent: () =>
          import('../../features/chat/chat-layout/chat-layout').then((m) => m.ChatLayoutComponent),
      },
      {
        path: ROUTES.DASHBOARD,
        loadComponent: () =>
          import('../../features/private/candidate/dashboard/dashboard').then(
            (m) => m.CandidateDashboardComponent
          ),
        children: dashboardRoutes,
      }
    ],
  },
];
